import React from "react";

import { faBrowser } from "@fortawesome/pro-solid-svg-icons/faBrowser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { TextField, TextFieldProps } from "@mapmycustomers/ui";

import { formatLink } from "@app/util/formatters";

import styles from "./TextFieldWithLink.module.scss";

const websiteRegex =
  /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

const WebsiteTextField: React.FC<TextFieldProps> = (props) => {
  const value = props.value ? String(props.value) : "";
  const isValid = websiteRegex.test(value);
  return (
    <TextField
      {...props}
      locked={props.disabled}
      suffix={
        <a href={isValid ? formatLink(value) : ""} rel="noreferrer" target="_blank">
          {isValid && (
            <div className={styles.textFieldIcon}>
              <FontAwesomeIcon className={styles.iconColor} icon={faBrowser} />
            </div>
          )}
        </a>
      }
    />
  );
};

export default WebsiteTextField;
